export const SHOW_LEFT_NAV = 'showLeftNav';
export const HIDE_LEFT_NAV = 'hideLeftNav';
export const SET_LEFT_NAV_TITLE_TEXT = 'setLeftNavTitleText';
export const SET_LEFT_NAV_LINKS = 'setLeftNavLinks';
